export default __webpack_public_path__ + "static/media/hoacai.b52fcc1a.png";